import React, { useRef, useState } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { SignaturePadField, FormButtons, validations } from '../../components'

let SignatureForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  height,
  width,
  isMobileDevice,
}) => {
  const targetRef = useRef()

  const [resetSignature, setResetSignature] = useState(false)

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row ref={targetRef}>
        <FormButtons
                hideClear={true}
                successBlock={true}
                submitting={submitting}
                pristine={pristine}
                reset={reset}
              />
        <div
          style={{
            width: isMobileDevice ? width : width * 0.5,
            margin: '0 auto',
          }}
        >
          <ReactBootstrap.Card>
            <ReactBootstrap.Card.Body className={' border border-dark'}>
              <Field
                resetSignature={resetSignature}
                component={SignaturePadField}
                validate={[validations.required]}
                height={isMobileDevice ? height - 200 : height - 200}
                width={isMobileDevice ? width : width * 0.5}
                name="customer_signature"
                label="Signature"
              ></Field>
              <FormButtons
                hideClear={true}
                successBlock={true}
                submitting={submitting}
                pristine={pristine}
                reset={reset}
              />
            </ReactBootstrap.Card.Body>
          </ReactBootstrap.Card>
        </div>
      </ReactBootstrap.Row>
    </form>
  )
}
SignatureForm = reduxForm({
  form: 'SignatureForm',
})(SignatureForm)

export default SignatureForm
